import { CustomBox } from "@/common/StyledComponents";
import { Heading } from "@/common/typography";
import { Button, Grid, IconButton, Modal, useTheme } from "@mui/material";
import { useState } from "react";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import { request } from "@/Api";
import { useDispatch } from "react-redux";
import { removeBill } from "./accountingBillsSlice";

export default function RefuteBillPopup({ bill, onRefuteSuccess }) {
    const [open, setOpen] = useState(false);
    const theme = useTheme();
    const dispatch = useDispatch();

    const handleRefute = () => {
        request
            .post(`accounting-bills/${bill.id}/refute-producer`, {
                reason: "Refuted by finance",
                message: `Bill ${bill.id} refuted by finance`,
            })
            .then((res) => {
                setOpen(false);
                const bill = res.data;
                dispatch(removeBill(bill));
                onRefuteSuccess(bill);
            });
    };
    return (
        <>
            <IconButton
                onClick={() => {
                    setOpen(true);
                }}
            >
                <WarningAmberRoundedIcon />
            </IconButton>
            <Modal
                onClose={() => {
                    setOpen(false);
                }}
                open={open}
            >
                <CustomBox
                    sx={{
                        background: theme.palette.background.default,
                        padding: 4,
                    }}
                >
                    <Heading>Refute Bill</Heading>
                    <p>{`Are you sure you want to refute the bill ${bill?.accounting_bill_number}?`}</p>
                    <Grid container spacing={2}>
                        <Grid item>
                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={() => {
                                    setOpen(false);
                                }}
                            >
                                Cancel
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleRefute}
                            >
                                Refute
                            </Button>
                        </Grid>
                    </Grid>
                </CustomBox>
            </Modal>
        </>
    );
}
